import axios from 'axios'

class OtpUtils {
  static async sendOtp(email, name) {
    const url = 'https://apis.ecoxurf.com/otp-generator/generate/otp'
    const data = {
      config: 'marketplace-website-login-otp',
      email: email,
      name: name,
      number: true,
    }

    const response = await axios.post(url, data).catch(e => e?.response)
    const parsed = response?.data
    console.log(parsed)
    if (!parsed?.data) return { sent: false }
    const responseToStore = {
      token: parsed.data.token,
      exp: parsed.data.exp,
    }
    OtpUtils.storeOtpData(responseToStore)
    return { sent: true }
  }

  static getOtpDelay() {
    const otpData = OtpUtils.getOtpData()
    if (!otpData) return { delayInMs: 0, timestamp: Date.now() }
    const expiryDelay = otpData.exp - Date.now()
    if (expiryDelay < 0) {
      OtpUtils.cleanOtpData()
      return { delayInMs: 0, timestamp: Date.now() }
    }
    return { delayInMs: expiryDelay, timestamp: otpData.exp }
  }

  static async confirmOtp(otp, email) {
    const otpData = OtpUtils.getOtpData()
    if (!otpData) return { confirmed: false, expired: true }
    const url =
      'https://apis.ecoxurf.com/otp-generator/validate/otp/' + otpData.token
    const data = {}
    const response = await axios.post(url, data).catch(e => e?.response)
    const parsed = response?.data
    if (!parsed.data) return { confirmed: false }
    if (!parsed.data.expirationTimestamp) {
      OtpUtils.cleanOtpData()
      return { confirmed: false, expired: true }
    }
    if (!parsed.data.otp) return { confirmed: false }
    if (`${otp}` !== `${parsed.data.otp}`) return { confirmed: false, otp, parsed: parsed.data.otp }
    OtpUtils.cleanOtpData()
    return { confirmed: true }
  }

  static async resendOtp(email, name) {
    const otpDelay = OtpUtils.getOtpDelay()
    if (otpDelay.delayInMs > 0) return { sent: false, notAvailable: true }
    return OtpUtils.sendOtp(email, name)
  }

  static storeOtpData(otpData) {
    localStorage.setItem('otpData', JSON.stringify(otpData))
  }

  static getOtpData() {
    const otpData = localStorage.getItem('otpData')
    if (otpData) return JSON.parse(otpData)
    return null
  }

  static cleanOtpData() {
    localStorage.removeItem('otpData')
  }
}

export { OtpUtils }
